import { render, staticRenderFns } from "./member_account_extract_detail.vue?vue&type=template&id=fa73dcc6&scoped=true"
import script from "./member_account_extract_detail.vue?vue&type=script&lang=js"
export * from "./member_account_extract_detail.vue?vue&type=script&lang=js"
import style0 from "./member_account_extract_detail.vue?vue&type=style&index=0&id=fa73dcc6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa73dcc6",
  null
  
)

export default component.exports